import React, { useEffect } from "react"

const CarSVG2 = ({data}) => {
    
    const setColors = () => {
        for(let i = 0; i < data.length; i++){
          if(data[i].damageSeverityScore <= 0.3 ){
            document.querySelectorAll(`.${data[i].partName.split(":").join("").split("/").join(" ").split(" ").join("_")}`).forEach(item => {
              item.classList.remove(item.classList[0])
              item.classList.add("yellow")
            })
          }
          else if(data[i].damageSeverityScore > 0.3 && data[i].damageSeverityScore <=0.7){
            document.querySelectorAll(`.${data[i].partName.split(":").join("").split("/").join(" ").split(" ").join("_")}`).forEach(item => {
              item.classList.remove(item.classList[0])
              item.classList.add("orange")
            })
          }else{
            document.querySelectorAll(`.${data[i].partName.split(":").join("").split("/").join(" ").split(" ").join("_")}`).forEach(item => {
              item.classList.remove(item.classList[0])
              item.classList.add("red")
            })
          }
        }
      }
      
    
      useEffect(()=>{
        setColors()
      },[])

    return (
  <svg
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 1000 1000"
    style={{
      enableBackground: "new 0 0 1000 1000",
    }}
    xmlSpace="preserve"
    {...{data}}
  >
    <style type="text/css">
      {
        "\n\t.red{fill:#FF0000;stroke:#000000;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.orange{fill:#FF8A00;stroke:#000000;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.yellow{fill:#FFB800;stroke:#000000;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st0{fill:#FFFFFF;stroke:#000000;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st1{fill:#404038;stroke:#000000;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st2{fill:#F8EC28;stroke:#000000;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st3{fill:#DED8D8;stroke:#000000;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st4{fill:#DED8D8;stroke:#000000;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st5{fill:#FFFFFF;stroke:#000000;stroke-linecap:round;stroke-miterlimit:10;}\n"
      }
    </style>
    <path
      className="st0 Left_Front_Bumper"
      d="M264.985,287.345c-1.2101-0.08-2.42-0.12-3.65-0.12c-4.24,0-8.37,0.47-12.3401,1.37l9.0901-56.68 c1.45-0.6,3-1.13,4.62-1.58l2.27,56.64L264.985,287.345z"
    />
    <path
      className="st0 Right_Front_Bumper"
      d="M751.0049,288.595c-3.97-0.9-8.0999-1.37-12.3398-1.37c-1.2301,0-2.4401,0.04-3.6501,0.12l0.01-0.37l2.27-56.64 c1.6201,0.45,3.17,0.98,4.6201,1.58L751.0049,288.595z"
    />
    <path
      className="st0"
      d="M629.12,666.64c-0.19,2.5699-0.31,4.3-0.36,5.0099c-0.77,10.9-0.43,19.41-5.02,25.62 c-4.59,6.22-14.39,14.9901-17.02,17.96c-2.64,2.97-7.92,3.66-8.6,0c-0.58-3.09-4.82-24.79-8.74-71.78c0,0,1.55,0.97,4.11,2.55 c0,0,7.74,67.06,8.37,67.83c0.64,0.77,18.64-15.45,20.69-23.5c2.04-8.03,2.52-25.85,2.52-25.85 C626.46,665.24,627.81,665.95,629.12,666.64z"
    />
    <path
      className="st0"
      d="M632.59,557.36l-6.13,92.43l3.74,1.58c1.53-21.6,4.09-57.42,6.72-94.23L632.59,557.36z M585.96,559 c-0.38,16.48-0.04,35.37,1.35,56.65c0.4,6.2,0.83,12.07,1.25,17.62l4.54,2.04c-2.89-20.95-3.22-76.42-3.22-76.42L585.96,559z  M641.64,434.58l-7,97.07l4.15-0.8c2.97-41.57,5.73-80.34,6.9-96.9C644.4,434.1,643.01,434.33,641.64,434.58z M595.21,486.71 c-3.51,10.71-6.87,28.64-8.45,53.7l4.81-0.92c0,0,0.17-28.78,9.02-56.68c13.1-39.16,43.8-85.16,43.8-85.16l-1.12,19.47 c0.93-0.89,2-1.93,2.9-2.92c0.61-0.66,1.21-1.03,1.75-1.1801c0,0,0.01-1.73,0.22-6.33c0.18-4.61,0.55-12.11,1.24-23.64 C649.38,383.05,610.51,435.92,595.21,486.71z"
    />
    <path
      className="st0 Hood"
      d="M666.84,238.55c-10.67,20.59-23.36,78.97-24.89,93.28c-0.73,6.8101-1.02,18.34-1.15,28.5l-0.04,20.69l8.62,2.03 c0.4-6.92,0.92-15.28,1.59-25.35c2.91-43.57,8.69-68.59,8.69-68.59c7.58-30.81,12.9301-41.32,12.9301-41.32L666.84,238.55z"
    />
    <path
      className="st0"
      d="M411.85,642.82c-0.0099,0.2-0.03,0.43-0.05,0.63c-3.92,46.99-8.16,68.69-8.75,71.78c-0.67,3.66-5.96,2.97-8.6,0 c-2.63-2.97-12.42-11.74-17.02-17.96c-2.73-3.7-3.72-8.21-4.22-13.55l-0.01-0.11l-0.01-0.1c-0.34-3.58-0.47-7.53-0.77-11.86 c-0.06-0.77-0.2-2.7-0.41-5.61c0.95-0.5,1.92-1.02,2.92-1.56c0,0,0.48,17.82,2.51,25.85c2.05,8.05,20.05,24.27,20.7,23.5 c0.62-0.77,8.36-67.83,8.36-67.83L411.85,642.82z"
    />
    <path
      className="st0 Hood"
      d="M360.58,381.26l-10.01,0.91c-0.39-6.73-0.9-14.82-1.55-24.47c-2.9-43.57-8.68-68.59-8.68-68.59 c-7.59-30.81-12.9301-41.32-12.9301-41.32l5.75-9.24c10.67,20.59,24.53,78.97,26.06,93.28c0.73,6.8101,1.03,18.34,1.16,28.5 l0.04,20.69c0.02,0.04,0.04,0.06,0.07,0.11C360.52,381.17,360.55,381.21,360.58,381.26z"
    />
    <path
      className="st0"
      d="M414.86,548.77c-1.31-29.47-5.01-50.19-8.9-62.06c-0.29-0.97-0.59-1.93-0.9-2.9c-0.3-0.95-0.61-1.91-0.94-2.86 c-0.34-1.03-0.7-2.06-1.07-3.1c-0.24-0.7-0.49-1.4-0.75-2.1c-0.07-0.22-0.15-0.43-0.23-0.65c-17.27-47.04-51.5-92.93-51.5-92.93 c0.72,12.09,1.11,19.83,1.29,24.51c0.11,2.59,0.2,5.02,0.24,6.37c0.83-0.25,1.82-0.04,2.91,1.15c0.9,0.99,1.96,2.03,2.9,2.92 l-1.12-19.47c0,0,30.69,46,43.79,85.16c8.85,27.9,9.02,56.68,9.02,56.68l-43.06-7.84l-7-97.07c-1.03-0.1899-2.72-0.37-4.05-0.5 c1.34,18.79,4.59,64.44,7.87,110.36c2.93,41.16,5.91,82.97,7.62,107.03l3.73-1.68l-6.13-92.43l42.73,1.53c0,0-0.34,55.47-3.24,76.42 l4.53-1.83c0.4301-5.61,0.85-11.55,1.26-17.83C415.55,589.83,415.69,567.52,414.86,548.77z"
    />
    <path
      id="_x38_1"
      className="st0 Right_Rear_Bumper"
      d="M739.485,742.725l-3.0599,46.8c0,0-16.77,11.41-27.4501,11.24c-1.42-0.02-2.7301-0.05-3.9401-0.08 l5.54-57.4701l0.71-7.36l0.03-0.3099c8.05,4.5699,17.39,7.1899,27.3501,7.1899C738.9349,742.735,739.215,742.735,739.485,742.725z"
    />
    <path
      id="_x38_0"
      className="st0 Left_Rear_Bumper"
      d="M294.975,800.715c-0.87,0.02-1.79,0.04-2.77,0.05c-10.6801,0.17-27.4501-11.24-27.4501-11.24 l-3.0599-46.8c9.83-0.0499,19.04-2.6599,26.99-7.1799l0.03,0.2999c0,0.01-0.01,0.01-0.01,0.01l0.7001,7.15l0.02,0.21 L294.975,800.715z"
    />
    <path
      id="_x37_9"
      className="st0 Right_Front_Bumper"
      d="M735.0249,286.975l0.1201-4c-14.1101,0.56-25.4301,4.39-34.17,10.38l-28.38-45.57l-5.75-9.24 c12.89-9.2,38.9399-11.23,38.9399-11.23s18.02-0.81,31.51,3.02L735.0249,286.975z"
    />
    <path
      id="_x37_8"
      className="st0 Left_Front_Bumper"
      d="M333.155,238.545l-5.75,9.24l-28.3801,45.57c-8.74-5.99-20.0599-9.82-34.1699-10.38l0.12,4 l-2.27-56.64c13.49-3.83,31.51-3.02,31.51-3.02S320.2649,229.345,333.155,238.545z"
    />
    <g id="_x37_7_1_">
      <rect
        x={473.1949}
        y={188.605}
        className="st0 License_Plate"
        width={53.62}
        height={9.07}
      />
      <rect
        id="_x37_7"
        x={473.1949}
        y={846.225}
        className="st0 License_Plate"
        width={53.62}
        height={9.06}
      />
    </g>
    <g id="_x37_6">
      <ellipse
        className="st1 Rear_PDC_Sensor"
        cx={398.215}
        cy={835.865}
        rx={3.3199}
        ry={2.85}
      />
      <path
        className="st1 Rear_PDC_Sensor"
        d="M501.955,837.465c0,1.5701-1.48,2.8501-3.3199,2.8501c-1.8301,0-3.3201-1.28-3.3201-2.8501 c0-1.58,1.49-2.85,3.3201-2.85C500.475,834.615,501.955,835.885,501.955,837.465z"
      />
      <ellipse
        className="st1 Rear_PDC_Sensor"
        cx={593.955}
        cy={835.865}
        rx={3.3199}
        ry={2.85}
      />
    </g>
    <path
      id="_x37_5"
      className="st0 Left_Side_Roof"
      d="M425.75,572.52V572.7c-0.01,20.69-1.11,45.98-2.6,70.75H411.8c0.02-0.2,0.04-0.4301,0.05-0.63 c0.25-3.01,0.5-6.12,0.75-9.34c0.4301-5.61,0.85-11.55,1.26-17.83c1.69-25.82,1.83-48.13,1-66.88c-1.31-29.47-5.01-50.19-8.9-62.06 c-0.29-0.97-0.59-1.93-0.9-2.9c-0.3-0.95-0.61-1.91-0.94-2.86c-0.34-1.03-0.7-2.06-1.07-3.1c-0.24-0.7-0.49-1.4-0.75-2.1 c-0.07-0.22-0.15-0.43-0.23-0.65l7.33-2.8l5.65-2.26c0.97,1.94,3.42,10.66,5.73,26.1c2.2,21.54,3.92,42.3199,4.48,58.67 C425.45,560.46,425.62,566.39,425.75,572.52z"
    />
    <path
      id="_x37_4"
      className="st0 Right_Side_Roof"
      d="M586.31,548.77c-0.83,18.75-0.69,41.06,1,66.88c0.66,10.12,1.37,19.37,2.07,27.8h-11.36 c-0.74-12.34-1.38-24.81-1.84-36.78c0.09-18.31,0.37-36.15,0.91-51.86c0.7-20.35,3.2-47.57,6.17-74.56 c1.24-5.68,2.3-9.08,2.86-10.21l5.66,2.26l7.15,3.24c-1.35,3.72-2.6,7.45-3.72,11.17C591.32,498.58,587.62,519.3,586.31,548.77z"
    />
    <g id="_x37_3_1_">
      <path
        className="st0 Left_Side_View_Mirror"
        d="M360.375,419.375c-2.3701,1.58-3.98,3.97-4.96,6.36c-1.25-1.38-4.4501-4.95-5.8301-6.93 c-1.72-2.49,0.38-4.15,1.3401-5.04c0.3398-0.32,0.73-0.59,1.1799-0.72c0.8201-0.25,1.8101-0.04,2.9099,1.16 c0.8901,0.98,1.9601,2.02,2.8901,2.91C359.2649,418.405,360.375,419.375,360.375,419.375z"
      />
      <path
        id="_x37_3"
        className="st0 Left_Side_View_Mirror"
        d="M370.585,437.315c0,0-5.47-1.67-11.04-2.73c-1.03-0.19-2.72-0.37-4.05-0.5099 c-0.45-0.05-0.8599-0.09-1.1899-0.13c0,0-0.12-0.84-0.1499-2.14v-0.07c-0.04-1.57,0.3398-3.79,1.26-6 c0.98-2.39,2.5898-4.78,4.96-6.36c0,0,2.6799-2.29,5.8099-1.46S372.115,421.745,370.585,437.315z"
      />
    </g>
    <g id="_x37_2_1_">
      <path
        className="st0 Right_Side_View_Mirror"
        d="M651.595,418.805c-1.73,2.49-5.3,6.7-5.3,6.7s-0.1599,2.22-0.45,6.23c0.0801-3.27-0.47-9.32-5.04-12.36 c0,0,1.1101-0.97,2.47-2.26c0.9301-0.89,2-1.93,2.8901-2.91c0.6199-0.67,1.21-1.04,1.75-1.18c0.9299-0.24,1.73,0.17,2.3398,0.7401 C651.215,414.655,653.3149,416.315,651.595,418.805z"
      />
      <path
        id="_x37_2"
        className="st0 Right_Side_View_Mirror"
        d="M645.845,431.735v0.07c-0.05,0.67-0.1001,1.38-0.15,2.14c-1.2999,0.15-2.6801,0.38-4.0599,0.64 c-5.5701,1.06-11.04,2.73-11.04,2.73c-1.53-15.57,1.27-18.57,4.3999-19.4c3.1301-0.83,5.8101,1.46,5.8101,1.46 C645.375,422.415,645.925,428.465,645.845,431.735z"
      />
    </g>
    <path
      id="_x37_1"
      className="st0 Left_Pillar_D"
      d="M423.15,643.45c-1.86,30.93-4.32,61.03-6.01,80.31c-0.52,0.46-17.02,15.47-39.31,29.88l-4.62-69.92 c0.5,5.34,1.49,9.85,4.22,13.55c4.6,6.22,14.39,14.9901,17.02,17.96c2.64,2.97,7.93,3.66,8.6,0c0.59-3.09,4.83-24.79,8.75-71.78 H423.15z"
    />
    <path
      id="_x37_0"
      className="st0 Right_Pillar_D"
      d="M628.18,681.18l-4.64,72.59c-22.75-14.68-39.5-30.02-39.5-30.02c-1.69-19.28-4.16-49.38-6.02-80.3 h11.36c3.92,46.99,8.16,68.69,8.74,71.78c0.68,3.66,5.96,2.97,8.6,0c2.63-2.97,12.4301-11.74,17.02-17.96 C626.89,693,627.72,687.65,628.18,681.18z"
    />
    <path
      id="_x36_9"
      className="st0 Left_Pillar_C"
      d="M412.6,633.48c-0.25,3.22-0.5,6.33-0.75,9.34L406.5,646c-6.65,4.07-20.15,12.23-31.57,18.48 c-1,0.54-1.97,1.06-2.92,1.56c-0.25-3.52-0.6-8.47-1.03-14.57l3.73-1.68l33.36-14.48L412.6,633.48z"
    />
    <path
      id="_x36_8_1_"
      className="st0 Right_Pillar_C"
      d="M630.2,651.37c-0.46,6.5-0.83,11.71-1.08,15.27c-1.31-0.69-2.66-1.4-4.05-2.16 c-11.42-6.25-24.92-14.41-31.58-18.48c-2.56-1.58-4.11-2.55-4.11-2.55c-0.27-3.27-0.54-6.66-0.82-10.1801l4.54,2.04l33.36,14.48 L630.2,651.37z"
    />
    <path
      id="_x36_7"
      className="st0 Left_Pillar_B"
      d="M415.2,559.03l-50.93-1.82c-0.3-4.25-0.61-8.5099-0.91-12.77c-0.32-4.53-0.65-9.05-0.97-13.55 l52.02,9.48c0.17,2.72,0.32,5.52,0.45,8.4C415.01,552.08,415.12,555.5,415.2,559.03z"
    />
    <path
      id="_x36_6"
      className="st0 Right_Pillar_B"
      d="M638.79,530.85c-0.32,4.51-0.65,9.04-0.97,13.59c-0.3,4.23-0.6,8.47-0.9,12.7l-4.33,0.22 l-42.71,1.53l-3.92,0.11c0.09-3.52,0.2-6.93,0.35-10.23c0.13-2.87,0.28-5.66,0.45-8.36l4.81-0.92l43.07-7.84L638.79,530.85z"
    />
    <path
      id="_x36_5_1_"
      className="st0 Left_Pillar_A"
      d="M409.4,472.3l-7.33,2.8c-17.27-47.04-51.5-92.93-51.5-92.93l10.01-0.91 c0.03,0.05,0.08,0.09,0.1,0.13c20.33,27.11,39.28,68.9399,46.05,84.66c0.02,0.03,0.04,0.06,0.05,0.09 c0.21,0.53,0.4399,1.04,0.67,1.56c0.26,0.6,0.49,1.16,0.71,1.65c0.1,0.25,0.19,0.48,0.29,0.69c0.09,0.22,0.17,0.41,0.25,0.6 c0.06,0.17,0.12,0.31,0.19,0.4399C409.22,471.88,409.4,472.3,409.4,472.3z"
    />
    <path
      id="_x36_4_1_"
      className="st0 Right_Pillar_A"
      d="M649.38,383.05c0,0-33.38,45.41-50.45,92.49l-7.15-3.24c0,0,0.17-0.42,0.5099-1.22 c0.06-0.1299,0.12-0.27,0.18-0.4399c0.11-0.25,0.22-0.5,0.33-0.76c0.03-0.08,0.06-0.17,0.11-0.24c0.14-0.3701,0.31-0.76,0.51-1.2 c1.12-2.65,2.27-5.26,3.43-7.83c0.33-0.74,0.67-1.47,1-2.22c1.11-2.44,2.23-4.84,3.35-7.21c0.33-0.7,0.66-1.39,0.99-2.07 c0.39-0.82,0.79-1.65,1.19-2.46c0.51-1.05,1.03-2.1,1.53-3.14c0.54-1.12,1.08-2.21,1.63-3.3c4.82-9.64,9.57-18.44,13.92-26.13 c1.22-2.14,2.4-4.2,3.54-6.16c0.29-0.49,0.57-0.98,0.85-1.47c0.42-0.71,0.84-1.4301,1.25-2.1201c0.21-0.34,0.41-0.6899,0.61-1.02 c0.21-0.35,0.4-0.68,0.6-1.01c0.27-0.45,0.53-0.9,0.79-1.32c0.26-0.43,0.51-0.85,0.78-1.28c0.63-1.06,1.27-2.09,1.86-3.08 c0.24-0.38,0.47-0.75,0.69-1.12c0.34-0.55,0.68-1.1,1-1.62c0.27-0.43,0.53-0.86,0.79-1.26c1.45-2.3,2.71-4.29,3.79-5.94 c0.16-0.25,0.31-0.48,0.46-0.72c1.63-2.5099,2.72-4.11,3.1201-4.7c0.03-0.05,0.0699-0.09,0.09-0.13c0.03-0.05,0.05-0.07,0.08-0.11 L649.38,383.05z"
    />
    <ellipse
      id="_x36_3"
      className="st0 Right_Rear_Wheel_Rim"
      cx={741.3049}
      cy={687.915}
      rx={33.48}
      ry={34.2}
    />
    <ellipse
      id="_x36_2"
      className="st0 Left_Rear_Wheel_Rim"
      cx={258.695}
      cy={687.915}
      rx={33.48}
      ry={34.2}
    />
    <ellipse
      id="_x36_1"
      className="st0 Right_Front_Wheel_Rim"
      cx={741.3049}
      cy={340.325}
      rx={33.48}
      ry={34.2}
    />
    <ellipse
      id="_x36_0"
      className="st0 Left_Front_Wheel_Rim"
      cx={258.695}
      cy={340.325}
      rx={33.48}
      ry={34.2}
    />
    <ellipse
      id="_x35_9"
      className="st0 Left_Rear_Door_Handle"
      cx={346.215}
      cy={655.3051}
      rx={2.51}
      ry={14}
    />
    <ellipse
      id="_x35_8"
      className="st0 Right_Rear_Door_Handle"
      cx={653.875}
      cy={655.3051}
      rx={2.51}
      ry={14}
    />
    <ellipse
      id="_x35_7"
      className="st0 Left_Front_Door_Handle"
      cx={337.365}
      cy={512.6951}
      rx={2.51}
      ry={14}
    />
    <ellipse
      id="_x35_6"
      className="st0 Right_Front_Door_Handle"
      cx={662.725}
      cy={512.6951}
      rx={2.51}
      ry={14}
    />
    <path
      id="_x35_5"
      className="st1 Left_Qtr_Extender"
      d="M320.6849,701.245c-6.99,31.76-31.2599,41.97-31.2599,41.97l-0.02-0.21l-0.6901-7.16 c1.9501-1.1899,3.7899-2.4399,5.51-3.75c6.7799-5.1599,11.8199-11.1599,15.3099-17.6c0.55-1,1.0601-2.01,1.55-3.0499 c3.25-6.89,5.0601-14.5701,5.0601-22.67c0-2.23-0.1401-4.4301-0.41-6.59c-1.11-9.05-4.5-17.4-9.6-24.49 c-0.21-0.3-0.42-0.6001-0.65-0.89c-0.33-0.4601-0.6801-0.9-1.03-1.3401c-0.26-0.34-0.5299-0.6799-0.8199-1.01 c-0.28-0.33-0.5601-0.6599-0.8501-0.99c-0.27-0.33-0.5599-0.6499-0.8699-0.97c-0.8901-0.98-1.8101-1.91-2.76-2.77 c-0.27-0.26-0.54-0.5-0.8-0.74c-0.28-0.26-0.5701-0.51-0.8601-0.75c-14.75-12.5599-32.3899-13.24-32.3899-13.24v-5.4199 c5.1599,0,40.48,2.8199,53.23,35.2999c0.8301,2.11,1.52,4.26,2.0901,6.4401C322.9449,681.045,322.865,691.345,320.6849,701.245z"
    />
    <path
      id="_x35_4"
      className="st1 Right_Qtr_Extender"
      d="M734.895,629.5751v5.4199c0,0-17.6401,0.6801-32.3901,13.23c-0.2799,0.24-0.5699,0.49-0.8499,0.75 c-0.6301,0.5701-1.25,1.15-1.8601,1.75c-0.3,0.3-0.6,0.61-0.8999,0.91c-0.3101,0.3-0.6001,0.61-0.8701,0.9301 c-0.59,0.62-1.1599,1.26-1.6899,1.9299c-0.54,0.65-1.0801,1.3201-1.5901,2c-0.1799,0.23-0.3499,0.46-0.5199,0.7001 c-0.13,0.1599-0.25,0.33-0.36,0.5c-0.2,0.2699-0.39,0.5499-0.5701,0.83c-9.3467,13.8303-12.4199,33.4038-5.2793,50.8451 c0.1638,0.3879,0.3164,0.7816,0.4893,1.1649c0.1201,0.29,0.26,0.58,0.3901,0.86c0.1199,0.26,0.24,0.52,0.3699,0.77 c4.3,8.97,11.4601,17.24,22.02,23.6899l-0.71,7.36c0,0-24.27-10.21-31.26-41.97c-2.1799-9.9-2.26-20.2,0.26-29.9299 c0.5701-2.1801,1.26-4.3301,2.0901-6.4401C694.415,632.395,729.735,629.5751,734.895,629.5751z"
    />
    <path
      id="_x35_3"
      className="st1 Left_Fender_Extender"
      d="M318.085,366.465c-8.24,22.59-29.15,32.77-42.9199,37.15c-7.5601,2.4-12.9701,3.06-12.9701,3.06 v-11.53c0,0,1.58,0.04,4.2101-0.23c0.1599-0.01,0.3199-0.03,0.48-0.05c0.34-0.03,0.6799-0.07,1.02-0.12 c6.3599-0.73,12.3799-2.55,17.8799-5.27c0.7001-0.33,1.3801-0.68,2.0601-1.05c0.26-0.14,0.52-0.28,0.78-0.43 c0.33-0.19,0.6699-0.38,1-0.58c4.54-2.63,9.09-6.17,13.1899-10.94c0.26-0.3,0.53-0.61,0.79-0.92c0.04-0.07,0.09-0.13,0.1399-0.18 c0.1501-0.19,0.3101-0.37,0.4501-0.56c0.11-0.13,0.2101-0.27,0.3099-0.4c7.3-9.16,11.6401-20.7,11.6401-33.23 c0-6.38-1.1201-12.5-3.1901-18.18c-0.0599-0.16-0.11-0.32-0.17-0.47c-1.3799-3.82-3.1699-7.34-5.27-10.44 c-0.1699-0.25-0.3398-0.51-0.52-0.76c-2.49-3.69-5.4399-7.0699-8.75-10.02c-0.3799-0.37-0.7699-0.71-1.1599-1.02 c-0.29-0.26-0.5801-0.51-0.88-0.75c-0.0499-0.04-0.09-0.08-0.14-0.11c-8.3101-6.7-18.6399-11.05-29.96-12.01c-0.01,0-0.01,0-0.02,0 c-0.37-0.03-0.73-0.06-1.1-0.08l-0.01-0.37l-0.12-4c14.11,0.56,25.4299,4.39,34.1699,10.38 C322.465,309.415,327.385,340.985,318.085,366.465z"
    />
    <path
      id="_x35_2"
      className="st1 Right_Fender_Extender"
      d="M737.8049,395.145v11.53c0,0-5.4099-0.66-12.97-3.06c-13.77-4.38-34.6799-14.56-42.9199-37.15 c-9.3-25.48-4.3801-57.05,19.0599-73.11c8.74-5.99,20.0599-9.82,34.17-10.38l-0.1201,4c-11.97,1.45-22.3499,5.21-31.23,12.57 c-0.29,0.24-0.58,0.48-0.8699,0.73c-0.6333,0.5366-1.2341,1.1074-1.8413,1.6713c-2.8596,2.6996-5.5391,5.8093-8.0789,9.3887 c-0.1799,0.25-0.3499,0.51-0.51,0.76c-1.8999,2.79-3.5299,5.92-4.8398,9.3c-0.02,0.05-0.04,0.1-0.0601,0.15 c-0.14,0.36-0.28,0.72-0.41,1.09c-0.08,0.22-0.16,0.45-0.24,0.67c-5.22,15.08-4.22,34.54,8.41,50.93 c0.13,0.17,0.26,0.35,0.3999,0.52c0.2001,0.25,0.4102,0.51,0.6201,0.76c0.27,0.34,0.54,0.67,0.84,0.99 c4.38,5.11,9.3099,8.81,14.17,11.49c0.27,0.16,0.5499,0.31,0.83,0.46c0.26,0.14,0.52,0.28,0.7799,0.41 c0.26,0.13,0.52,0.26,0.79,0.39c6.7511,3.326,13.1526,4.7676,17.6658,5.3979c0.3021,0.0386,0.6006,0.0883,0.9043,0.1221 c0.25,0.04,0.5,0.06,0.76,0.09c0.1599,0.02,0.3199,0.04,0.48,0.05C736.225,395.185,737.8049,395.145,737.8049,395.145z"
    />
    <path
      id="_x35_1"
      className="st0 Fuel_Door"
      d="M662.9949,730.295c0,5.0399-4.0798,9.12-9.1199,9.12s-9.1201-4.0801-9.1201-9.12 c0-5.04,4.0801-9.12,9.1201-9.12S662.9949,725.255,662.9949,730.295z"
    />
    <path
      id="_x35_0"
      className="st2 Left_Indicator"
      d="M340.9349,342.715v15.66c0,2.96-2.4,5.37-5.36,5.37s-5.36-2.41-5.36-5.37v-15.66 c0-2.96,2.4-5.36,5.36-5.36c1.48,0,2.8201,0.6,3.79,1.57C340.335,339.895,340.9349,341.235,340.9349,342.715z"
    />
    <path
      id="_x34_9"
      className="st2 Right_Indicator"
      d="M669.7849,342.715v15.66c0,2.96-2.3999,5.37-5.3599,5.37c-2.9601,0-5.3601-2.41-5.3601-5.37v-15.66 c0-1.48,0.6001-2.82,1.5701-3.79c0.97-0.97,2.3099-1.57,3.79-1.57C667.385,337.355,669.7849,339.755,669.7849,342.715z"
    />
    <path
      id="_x34_8"
      className="st0 Left_Stair"
      d="M241.2749,411.705v206.16c0,2.78-2.25,5.02-5.02,5.02c-2.7699,0-5.0199-2.24-5.0199-5.02v-206.16 c0-2.78,2.25-5.03,5.0199-5.03c1.3801,0,2.6401,0.56,3.55,1.47C240.715,409.055,241.2749,410.315,241.2749,411.705z"
    />
    <path
      id="_x34_7"
      className="st0 Right_Stair"
      d="M768.7649,411.705v206.16c0,2.78-2.25,5.02-5.02,5.02c-2.7699,0-5.0199-2.24-5.0199-5.02v-206.16 c0-1.39,0.5599-2.65,1.47-3.56c0.91-0.91,2.16-1.47,3.5499-1.47C766.5149,406.675,768.7649,408.925,768.7649,411.705z"
    />
    <path
      id="_x34_6"
      className="st0 Left_Running_Board"
      d="M265.105,634.8151v0.13c-1.25-0.0901-2.5-0.13-3.77-0.13c-2.52,0-5.01,0.1699-7.4399,0.49 l-0.02-0.3301l-3.4-239.49l-0.02-1.41c3.51,0.7,7.15,1.0699,10.88,1.0699c0.24,0,0.47,0,0.71-0.0099l0.15,11.54l1.6901,132.67 L265.105,634.8151z"
    />
    <path
      id="_x34_5"
      className="st0 Right_Running_Board"
      d="M749.5449,394.075l-0.02,1.41l-3.3999,239.49l-0.02,0.3301c-2.4299-0.3201-4.92-0.49-7.4399-0.49 c-1.27,0-2.52,0.0399-3.77,0.13v-0.13l1.22-95.3301l1.6899-132.81l0.15-11.54c0.23,0.0099,0.4701,0.0099,0.7101,0.0099 C742.395,395.145,746.0349,394.775,749.5449,394.075z"
    />
    <rect
      id="_x34_4"
      x={276.385}
      y={543.645}
      className="st1 Left_Rear_Door_Moulding"
      width={16.01}
      height={82.72}
    />
    <rect
      id="_x34_3"
      x={707.6949}
      y={543.645}
      className="st1 Right_Rear_Door_Moulding"
      width={16.01}
      height={82.72}
    />
    <rect
      id="_x34_2"
      x={276.385}
      y={422.455}
      className="st1 Left_Front_Door_Moulding"
      width={16.01}
      height={82.73}
    />
    <rect
      id="_x34_1"
      x={707.6949}
      y={422.455}
      className="st1 Right_Front_Door_Moulding"
      width={16.01}
      height={82.73}
    />
    <path
      id="_x34_0"
      className="st3 Left_Rear_Reflector_Bottom"
      d="M423.655,853.615l-11.8701,8.04H391.615C391.615,861.655,400.5549,849.915,423.655,853.615z"
    />
    <path
      id="_x33_9"
      className="st3 Right_Rear_Reflector_Bottom"
      d="M608.385,861.655h-20.17l-11.87-8.04C599.4449,849.915,608.385,861.655,608.385,861.655z"
    />
    <g id="_x33_8_1_">
      <polygon
        id="_x33_8.1"
        className="st3 Emblem"
        points="508.6849,829.725 488.595,829.725 498.645,813.495  "
      />
      <polygon
        id="_x33_8"
        className="st4 Emblem"
        points="508.6849,242.095 498.635,258.325 488.595,242.095  "
      />
    </g>
    <g id="_x33_7_1_">
      <path
        id="_x33_7"
        className="st1 Front_PDC_Sensor"
        d="M420.655,166.675c0,1.58-1.48,2.85-3.3101,2.85c-1.8401,0-3.3201-1.27-3.3201-2.85 c0-1.57,1.48-2.85,3.3201-2.85C419.175,163.825,420.655,165.105,420.655,166.675z"
      />
      <path
        className="st1 Front_PDC_Sensor"
        d="M582.0649,166.675c0,1.58-1.49,2.85-3.3201,2.85c-1.8298,0-3.3198-1.27-3.3198-2.85 c0-1.57,1.49-2.85,3.3198-2.85C580.575,163.825,582.0649,165.105,582.0649,166.675z"
      />
      <path
        className="st1 Front_PDC_Sensor"
        d="M501.955,165.975c0,1.57-1.48,2.85-3.3199,2.85c-1.8301,0-3.3201-1.28-3.3201-2.85 c0-1.58,1.49-2.85,3.3201-2.85C500.475,163.125,501.955,164.395,501.955,165.975z"
      />
    </g>
    <g id="_x33_6">
      <path
        className="st3 Left_Fog_Light"
        d="M411.415,190.535c0,3.63-2.9501,6.57-6.5801,6.57s-6.5801-2.94-6.5801-6.57c0-3.64,2.9501-6.58,6.5801-6.58 S411.415,186.895,411.415,190.535z"
      />
      <path
        className="st0 Left_Fog_Light"
        d="M425.235,184.035c-6.38-1.37-20.64-3.06-25.0699-3.61c-4.4202-0.56-8.25,4.46-5.8701,10.25 c2.39,5.79,4.05,10.9,10.4301,9.49c6.38-1.4,17.36-4.81,21.74-6.42C430.855,192.125,429.7849,185.015,425.235,184.035z  M404.835,197.105c-3.63,0-6.5801-2.94-6.5801-6.57c0-3.64,2.9501-6.58,6.5801-6.58s6.5801,2.94,6.5801,6.58 C411.415,194.165,408.465,197.105,404.835,197.105z"
      />
    </g>
    <g id="_x33_5">
      <path
        className="st0 Right_Fog_Light"
        d="M599.825,180.425c-4.4199,0.55-18.6799,2.24-25.0601,3.61c-4.5499,0.98-5.6199,8.09-1.23,9.71 c4.3801,1.61,15.3601,5.02,21.74,6.42c6.3801,1.41,8.04-3.7,10.4301-9.49C608.085,184.885,604.2549,179.865,599.825,180.425z  M595.165,197.105c-3.6301,0-6.5801-2.94-6.5801-6.57c0-3.64,2.95-6.58,6.5801-6.58c3.6299,0,6.5798,2.94,6.5798,6.58 C601.7449,194.165,598.7949,197.105,595.165,197.105z"
      />
      <path
        className="st3 Right_Fog_Light"
        d="M601.7449,190.535c0,3.63-2.95,6.57-6.5798,6.57c-3.6301,0-6.5801-2.94-6.5801-6.57 c0-3.64,2.95-6.58,6.5801-6.58C598.7949,183.955,601.7449,186.895,601.7449,190.535z"
      />
    </g>
    <path
      id="_x33_4"
      className="st0 Right_Rear_Tyre"
      d="M741.3049,643.455c-24.03,0-43.52,19.91-43.52,44.4601c0,24.5499,19.49,44.46,43.52,44.46 c24.04,0,43.52-19.91,43.52-44.46C784.825,663.365,765.345,643.455,741.3049,643.455z M741.3049,722.115 c-18.49,0-33.48-15.3099-33.48-34.2s14.99-34.2001,33.48-34.2001s33.48,15.3101,33.48,34.2001S759.7949,722.115,741.3049,722.115z"
    />
    <path
      id="_x33_3"
      className="st0 Left_Rear_Tyre"
      d="M258.6949,643.455c-24.0399,0-43.5199,19.91-43.5199,44.4601c0,24.5499,19.48,44.46,43.5199,44.46 c24.03,0,43.52-19.91,43.52-44.46C302.215,663.365,282.725,643.455,258.6949,643.455z M258.6949,722.115 c-18.49,0-33.48-15.3099-33.48-34.2s14.99-34.2001,33.48-34.2001s33.4801,15.3101,33.4801,34.2001 S277.1849,722.115,258.6949,722.115z"
    />
    <path
      id="_x33_2"
      className="st0 Right_Front_Tyre"
      d="M741.3049,295.865c-24.03,0-43.52,19.91-43.52,44.46c0,24.55,19.49,44.46,43.52,44.46 c24.04,0,43.52-19.91,43.52-44.46C784.825,315.775,765.345,295.865,741.3049,295.865z M741.3049,374.525 c-18.49,0-33.48-15.31-33.48-34.2c0-18.89,14.99-34.2,33.48-34.2s33.48,15.31,33.48,34.2 C774.7849,359.215,759.7949,374.525,741.3049,374.525z"
    />
    <path
      id="_x33_1"
      className="st0 Left_Front_Tyre"
      d="M258.6949,295.865c-24.0399,0-43.5199,19.91-43.5199,44.46c0,24.55,19.48,44.46,43.5199,44.46 c24.03,0,43.52-19.91,43.52-44.46C302.215,315.775,282.725,295.865,258.6949,295.865z M258.6949,374.525 c-18.49,0-33.48-15.31-33.48-34.2c0-18.89,14.99-34.2,33.48-34.2s33.4801,15.31,33.4801,34.2 C292.175,359.215,277.1849,374.525,258.6949,374.525z"
    />
    <path
      className="st3 Left_Qtr_Window_Glass"
      d="M406.5,646c0,0-7.74,67.06-8.36,67.83c-0.65,0.77-18.65-15.45-20.7-23.5c-2.03-8.03-2.51-25.85-2.51-25.85 C386.35,658.23,399.85,650.07,406.5,646z"
    />
    <path
      id="_x32_9"
      className="st3 Right_Qtr_Window_Glass"
      d="M625.075,664.475c0,0-0.48,17.8201-2.52,25.86c-2.05,8.04-20.05,24.26-20.6899,23.4901 c-0.63-0.77-8.3701-67.8301-8.3701-67.8301C600.145,650.0651,613.645,658.225,625.075,664.475z"
    />
    <path
      className="st3 Left_Rear_Window_Glass"
      d="M411.31,558.89c0,0-0.34,55.47-3.24,76.42l-33.36,14.48l-6.13-92.43L411.31,558.89z"
    />
    <path
      id="_x32_7"
      className="st3 Right_Rear_Window_Glass"
      d="M632.595,557.355l-6.13,92.4301l-33.36-14.48c-2.89-20.9501-3.23-76.42-3.23-76.42L632.595,557.355 z"
    />
    <path
      id="_x32_6"
      className="st3 Left_Front_Window_Glass"
      d="M409.605,539.485l-43.0601-7.83l-7-97.07c5.5701,1.06,11.04,2.73,11.04,2.73 c1.53-15.57-1.27-18.57-4.4-19.4s-5.8099,1.46-5.8099,1.46s-1.1101-0.97-2.47-2.26l-1.1101-19.46c0,0,30.6901,46,43.79,85.15 C409.4349,510.715,409.605,539.485,409.605,539.485z"
    />
    <path
      id="_x32_5"
      className="st3 Right_Front_Window_Glass"
      d="M630.595,437.315c0,0,5.47-1.67,11.04-2.73l-7,97.07l-43.0601,7.83c0,0,0.1699-28.77,9.02-56.68 c13.1-39.15,43.79-85.15,43.79-85.15l-1.1101,19.46c-1.3599,1.29-2.47,2.26-2.47,2.26s-2.6799-2.29-5.8101-1.46 C631.865,418.745,629.0649,421.745,630.595,437.315z"
    />
    <path
      id="_x32_4"
      className="st0 Left_Qtr_Panel"
      d="M377.83,753.64c-3.83,2.48-7.83,4.9399-11.95,7.3c0,0-11.47,6.85-18.97,10.3 c0,0-23.56,11.02-29.23,12.61c-1.42,4.28-2.37,8.41-2.37,8.41s-2.56,3.91-5.28,5.94c-2.47,1.87-6.35,2.3199-15.0601,2.5099 l-5.54-57.5c0,0,24.26-10.2,31.25-41.96c2.18-9.9,2.26-20.2-0.25-29.93c0,0,27.24,3.49,37.1,1.28c2.7599-0.64,8.15-3.2,14.48-6.56 c0.21,2.91,0.35,4.84,0.41,5.61c0.3,4.33,0.43,8.28,0.77,11.86l0.01,0.1l0.01,0.11L377.83,753.64z"
    />
    <path
      id="_x32_3"
      className="st0 Right_Qtr_Panel"
      d="M679.31,701.25c-2.17-9.9-2.26-20.2,0.26-29.93c0,0-27.24,3.49-37.11,1.28 c-2.6-0.59-7.51-2.89-13.34-5.96c-0.19,2.5699-0.31,4.3-0.36,5.0099c-0.18,2.52-0.29,4.91-0.43,7.17c-0.05,0.8-0.09,1.58-0.15,2.35 v0.01l-4.64,72.59c3.77,2.4301,7.71,4.85,11.76,7.17c0,0,12.51,7.32,18.97,10.3c0,0,23.55,11.02,29.24,12.61 c1.41,4.28,2.35,8.41,2.35,8.41s2.57,3.91,5.29,5.94c2.35,1.79,6,2.28,13.88,2.49l5.54-57.48 C710.57,743.21,686.3,733.01,679.31,701.25z M653.88,739.42c-5.05,0-9.13-4.09-9.13-9.12c0-5.04,4.08-9.12,9.13-9.12 c5.04,0,9.11,4.08,9.11,9.12C662.99,735.33,658.92,739.42,653.88,739.42z"
    />
    <path
      id="_x32_2"
      className="st0 Left_Rear_Door"
      d="M370.98,651.47c-1.71-24.06-4.69-65.87-7.62-107.03c-25.06-10.44-88.33-5.98-99.47-5.09l1.21,95.47 V629.58c5.16,0,40.48,2.8101,53.23,35.3c0.84,2.11,1.52,4.26,2.1,6.44c0,0,27.24,3.49,37.1,1.28c2.7599-0.64,8.15-3.2,14.48-6.56 C371.76,662.52,371.41,657.57,370.98,651.47z M292.4,626.37h-16.01v-82.73h16.01V626.37z M346.21,669.31c-1.39,0-2.51-6.27-2.51-14 c0-7.73,1.12-14,2.51-14c1.38,0,2.5099,6.27,2.5099,14C348.72,663.04,347.59,669.31,346.21,669.31z"
    />
    <path
      id="_x32_1"
      className="st0 Right_Rear_Door"
      d="M736.115,539.485c0,0-70.77-6.52-98.29,4.9501c-3.72,52.1899-7.52,105.4399-8.7,122.21 c5.83,3.0699,10.74,5.36,13.34,5.95c9.87,2.2101,37.11-1.2799,37.11-1.2799c0.5701-2.1801,1.26-4.3301,2.0901-6.4401 c12.75-32.48,48.0699-35.2999,53.23-35.2999v5.24L736.115,539.485z M653.875,669.3051c-1.39,0-2.51-6.27-2.51-14s1.12-14,2.51-14 c1.3799,0,2.51,6.27,2.51,14S655.2549,669.3051,653.875,669.3051z M723.705,626.365h-16.01v-82.72h16.01V626.365z"
    />
    <path
      id="_x32_0"
      className="st0 Left_Front_Door"
      d="M355.4949,434.075c-0.45-0.05-0.8599-0.09-1.1899-0.13c0,0-0.12-0.84-0.1499-2.14v-0.07 c-0.04-1.57,0.3398-3.79,1.26-6c-1.25-1.38-4.4501-4.95-5.8301-6.93c-1.72-2.49,0.38-4.15,1.3401-5.04 c0.3398-0.32,0.73-0.59,1.1799-0.72c-0.04-1.34-0.13-3.77-0.24-6.37c0,0-21.2-9.56-76.7-3.06c-7.5601,2.4-12.9701,3.06-12.9701,3.06 l1.6901,132.67c11.1499-0.88,74.4199-5.35,99.48,5.0901C360.085,498.525,356.835,452.865,355.4949,434.075z M292.395,505.185h-16.01 v-82.73h16.01V505.185z M337.365,526.6951c-1.39,0-2.51-6.27-2.51-14c0-7.7301,1.12-14,2.51-14c1.3799,0,2.51,6.27,2.51,14 C339.875,520.425,338.7449,526.6951,337.365,526.6951z"
    />
    <path
      id="_x31_9"
      className="st0 Right_Front_Door"
      d="M724.835,403.615c-48.22-5.65-71.4399,1.18-76.7,3.07c-0.2001,4.6-0.22,6.34-0.22,6.34 c0.9299-0.24,1.73,0.17,2.3398,0.7401c0.9601,0.89,3.0601,2.55,1.3401,5.04c-1.73,2.49-5.3,6.7-5.3,6.7s-0.1599,2.22-0.45,6.23v0.07 c-0.03,1.3-0.15,2.14-0.15,2.14c-1.3099,18.35-4.5599,64.0099-7.87,110.49c27.52-11.4701,98.29-4.9501,98.29-4.9501l1.6899-132.81 C737.8049,406.675,732.395,406.015,724.835,403.615z M662.725,526.6951c-1.39,0-2.51-6.27-2.51-14c0-7.7301,1.12-14,2.51-14 s2.51,6.27,2.51,14C665.235,520.425,664.115,526.6951,662.725,526.6951z M723.705,505.185h-16.01v-82.73h16.01V505.185z"
    />
    <path
      id="_x31_8"
      className="st0 Left_Fender"
      d="M350.575,382.165c-0.3999-6.73-0.9099-14.82-1.55-24.47c-2.8999-43.57-8.6799-68.59-8.6799-68.59 c-7.5901-30.81-12.9399-41.32-12.9399-41.32l-28.3801,45.57c23.4401,16.06,28.3601,47.63,19.0601,73.11 c-8.24,22.59-29.15,32.77-42.9199,37.15c55.5-6.5,76.7,3.06,76.7,3.06C351.675,401.995,351.2949,394.255,350.575,382.165z  M340.9349,358.375c0,2.96-2.4,5.37-5.36,5.37s-5.36-2.41-5.36-5.37v-15.66c0-2.96,2.4-5.36,5.36-5.36c1.48,0,2.8201,0.6,3.79,1.57 c0.97,0.97,1.5699,2.31,1.5699,3.79V358.375z"
    />
    <path
      id="_x31_7"
      className="st0 Right_Fender"
      d="M681.915,366.465c-9.3-25.48-4.3801-57.05,19.0599-73.11l-28.38-45.57 c0,0-5.3501,10.51-12.9399,41.32c0,0-5.78,25.02-8.6801,68.59c-0.67,10.07-1.1901,18.43-1.6,25.35 c-0.6801,11.53-1.05,19.03-1.24,23.64c5.26-1.89,28.48-8.72,76.7-3.07C711.0649,399.235,690.155,389.055,681.915,366.465z  M669.7849,358.375c0,2.96-2.3999,5.37-5.3599,5.37c-2.9601,0-5.3601-2.41-5.3601-5.37v-15.66c0-1.48,0.6001-2.82,1.5701-3.79 c0.97-0.97,2.3099-1.57,3.79-1.57c2.96,0,5.3599,2.4,5.3599,5.36V358.375z"
    />
    <path
      id="_x31_6"
      className="st3 Right_Taillight"
      d="M600.725,787.995c-3.39,3.99-9.59,6.04-14.75,7.09c-4.74,0.9601-8.62,1.0801-8.62,1.0801 l-10.5901-19.15l37.02-7.02c0,0,0.1201,0.36,0.27,0.99C604.725,773.745,606.0249,781.755,600.725,787.995z"
    />
    <path
      id="_x31_5"
      className="st3 Left_Taillight"
      d="M433.235,777.015l-10.59,19.15c0,0-3.8701-0.12-8.6201-1.0801 c-5.1599-1.0499-11.3599-3.1-14.75-7.09c-5.2999-6.24-4-14.25-3.33-17.01c0.15-0.63,0.27-0.99,0.27-0.99L433.235,777.015z"
    />
    <path
      id="_x31_4"
      className="st3 Right_Headlight"
      d="M608.165,247.695c-2.2101,0.47-19.74-1.15-19.74-1.15c-4.3801-2.12-23.8701-10.08-23.5-12.79v-0.01 c0.3999-2.71,7.8499-6.39,13.1199-6.9c9.8101-1.16,17.3801,2.73,22.96,7.65c0.9601,0.85,1.8601,1.72,2.7001,2.61 C609.4449,243.145,610.385,247.225,608.165,247.695z"
    />
    <path
      id="_x31_3"
      className="st3 Left_Headlight"
      d="M435.075,233.755c0.37,2.71-19.12,10.67-23.5,12.79c0,0-17.53,1.62-19.75,1.15 c-2.21-0.47-1.27-4.55,4.47-10.59c0.8401-0.89,1.74-1.76,2.7-2.61c5.5801-4.92,13.1501-8.81,22.9601-7.65 C427.235,227.355,434.6949,231.045,435.075,233.755z"
    />
    <path
      id="_x31_2"
      className="st0 Bumper_Grill_Bottom"
      d="M563.615,185.785c0,0-28.76-1.75-63.6101-1.75c-34.8499,0-63.6199,1.75-63.6199,1.75 c-3.74-4.94-6.0801-12.34-1.3601-13.24c18.76-2.04,64.98-2.17,64.98-2.17s46.2101,0.13,64.9801,2.17 C569.705,173.445,567.365,180.845,563.615,185.785z"
    />
    <path
      id="_x31_1"
      className="st0 Bumper_Grill_Top"
      d="M563.325,219.395c-5.62,4.35-14.6799,10.35-27.96,10.35s-35.3601,0-35.3601,0s-22.0898,0-35.3599,0 c-13.28,0-22.3401-6-27.9601-10.35c-5.62-4.34-8.6801-9.19-3.1901-11.48c22.5901-7.92,66.51-7.41,66.51-7.41 s43.9102-0.51,66.51,7.41C572.0049,210.205,568.9349,215.055,563.325,219.395z"
    />
    <rect
      id="_x31_0"
      x={415.0249}
      y={130.617}
      className="st0 Front_Bumper_Cover"
      width={168.04}
      height={17.0213}
    />
    <path
      id="_x39_"
      className="st0 Front_Bumper"
      d="M614.0349,165.015c-0.34-3.38-3.1799-5.96-6.58-5.96h-33.24c0,0-4.52,1.96-6.5599,1.96h-67.6501 c0,0-65.6199,0-67.6599,0s-6.5601-1.96-6.5601-1.96h-33.24c-3.3999,0-6.24,2.58-6.58,5.96l-5.7101,58.04l18.74,11.44 c5.5801-4.92,13.1501-8.81,22.9601-7.65c5.28,0.51,12.74,4.2,13.12,6.91c15.4399,3.8,34.14,5.08,35.03,5.14c0.02,0,0.03,0,0.03,0 c3.72-0.24,7.2-0.35,10.1199-0.35c14.05,0,19.75,0,19.75,0h19.74c2.9202,0,6.4001,0.11,10.1201,0.35c0,0,0.01,0,0.03,0 c0.8899-0.06,19.59-1.34,35.03-5.14v-0.01c0.3999-2.71,7.8499-6.39,13.1199-6.9c9.8101-1.16,17.3801,2.73,22.96,7.65l18.74-11.44 L614.0349,165.015z M578.7449,163.825c1.8301,0,3.3201,1.28,3.3201,2.85c0,1.58-1.49,2.85-3.3201,2.85 c-1.8298,0-3.3198-1.27-3.3198-2.85C575.425,165.105,576.915,163.825,578.7449,163.825z M498.635,163.125 c1.84,0,3.3199,1.27,3.3199,2.85c0,1.57-1.48,2.85-3.3199,2.85c-1.8301,0-3.3201-1.28-3.3201-2.85 C495.3149,164.395,496.8049,163.125,498.635,163.125z M435.0249,172.545c18.76-2.04,64.98-2.17,64.98-2.17 s46.2101,0.13,64.9801,2.17c4.72,0.9,2.38,8.3-1.37,13.24c0,0-28.76-1.75-63.6101-1.75c-34.8499,0-63.6199,1.75-63.6199,1.75 C432.645,180.845,430.3049,173.445,435.0249,172.545z M526.8149,188.605v9.07h-53.62v-9.07H526.8149z M417.345,163.825 c1.8301,0,3.3101,1.28,3.3101,2.85c0,1.58-1.48,2.85-3.3101,2.85c-1.8401,0-3.3201-1.27-3.3201-2.85 C414.0249,165.105,415.5049,163.825,417.345,163.825z M426.465,193.745c-4.38,1.61-15.36,5.02-21.74,6.42 c-6.38,1.41-8.04-3.7-10.4301-9.49c-2.3799-5.79,1.45-10.81,5.8701-10.25c4.4299,0.55,18.6899,2.24,25.0699,3.61 C429.7849,185.015,430.855,192.125,426.465,193.745z M563.325,219.395c-5.62,4.35-14.6799,10.35-27.96,10.35s-35.3601,0-35.3601,0 s-22.0898,0-35.3599,0c-13.28,0-22.3401-6-27.9601-10.35c-5.62-4.34-8.6801-9.19-3.1901-11.48c22.5901-7.92,66.51-7.41,66.51-7.41 s43.9102-0.51,66.51,7.41C572.0049,210.205,568.9349,215.055,563.325,219.395z M605.705,190.675 c-2.39,5.79-4.0499,10.9-10.4301,9.49c-6.3799-1.4-17.3599-4.81-21.74-6.42c-4.3899-1.62-3.3199-8.73,1.23-9.71 c6.3801-1.37,20.6401-3.06,25.0601-3.61C604.2549,179.865,608.085,184.885,605.705,190.675z"
    />
    <g id="_x38__1_">
      <path
        className="st0 Rear_Bumper_Cover"
        d="M577.105,843.015c-9.96,0-77.1101,0-77.1101,0s-67.1399,0-77.0999,0c-9.9601,0-39.23,8.29-39.23,8.29 c0.5599,3.64,1.21,7.3199,1.95,10.99c1.6599,6.51,8.9399,13.7899,21.58,13.7899h13.78c0,0,13.41-17.24,32.9401-17.24 c19.5299,0,46.0798,0,46.0798,0s26.5601,0,46.0901,0s32.9399,17.24,32.9399,17.24h13.78c12.64,0,19.92-7.2799,21.5801-13.7899 c0.74-3.67,1.3899-7.35,1.95-10.99C616.335,851.3051,587.0649,843.015,577.105,843.015z M411.7849,861.655H391.615 c0,0,8.9399-11.74,32.04-8.04L411.7849,861.655z M526.8149,855.285h-53.62v-9.0601h53.62V855.285z M588.215,861.655l-11.87-8.04 c23.1-3.7,32.04,8.04,32.04,8.04H588.215z"
      />
      <path
        id="_x38_"
        className="st0 Rear_Bumper_Cover"
        d="M579.0249,876.085c-26.7899,0-79.03,0-79.03,0s-52.24,0-79.0199,0c0,0,13.41-17.24,32.9401-17.24 c19.5299,0,46.0798,0,46.0798,0s26.5601,0,46.0901,0S579.0249,876.085,579.0249,876.085z"
      />
    </g>
    <path
      id="_x37_"
      className="st0 Rear_Bumper"
      d="M617.4449,788.635c-2.6801-9.0599-13.39-17.65-13.39-17.65c0.67,2.76,1.97,10.77-3.33,17.01 c-3.39,3.99-9.59,6.04-14.75,7.09c0,0-0.4401,23.55-3.63,36.8301H417.655c-3.1901-13.28-3.6301-36.8301-3.6301-36.8301 c-5.1599-1.0499-11.3599-3.1-14.75-7.09c-5.2999-6.24-4-14.25-3.33-17.01c0,0-10.71,8.5901-13.39,17.65 c-2.37,8.03-3.25,34.39,1.1101,62.67c0,0,29.2699-8.29,39.23-8.29c9.96,0,77.0999,0,77.0999,0s67.1501,0,77.1101,0 s39.23,8.29,39.23,8.29C620.6949,823.025,619.8149,796.665,617.4449,788.635z M398.215,838.715c-1.84,0-3.3199-1.2699-3.3199-2.85 c0-1.5699,1.48-2.85,3.3199-2.85c1.83,0,3.3199,1.28,3.3199,2.85C401.5349,837.4451,400.0449,838.715,398.215,838.715z  M498.635,840.3151c-1.8301,0-3.3201-1.28-3.3201-2.8501c0-1.58,1.49-2.85,3.3201-2.85c1.84,0,3.3199,1.27,3.3199,2.85 C501.955,839.035,500.475,840.3151,498.635,840.3151z M593.955,838.715c-1.83,0-3.3199-1.2699-3.3199-2.85 c0-1.5699,1.49-2.85,3.3199-2.85c1.84,0,3.3199,1.28,3.3199,2.85C597.2749,837.4451,595.7949,838.715,593.955,838.715z"
    />
    <path
      id="_x36_"
      className="st5 Tail_Gate"
      d="M577.355,796.165l-10.5901-19.15l-29.8099-0.76h-1.1801c-15.4399,0-34.59,0-34.59,0s-19.15,0-34.6,0 h-3.35l-30,0.76l-10.59,19.15c0,0-3.8701-0.12-8.6201-1.0801c0,0,0.4401,23.55,3.6301,36.8301H582.345 c3.1899-13.28,3.63-36.8301,3.63-36.8301C581.235,796.045,577.355,796.165,577.355,796.165z M488.595,829.725l10.05-16.23 l10.0399,16.23H488.595z"
    />
    <path
      id="_x35_"
      className="st3 Rear_Glass"
      d="M577.395,734.885c0.02,1.08,0.01,2.14-0.03,3.1801v0.0299c-0.3701,9.27-3.1899,16.5-7.3501,22.05 c-0.08,0.12-0.1699,0.23-0.25,0.34c-5.22,7.15-12.3599,11.3101-19.02,13.55c-0.2,0.0699-0.3999,0.13-0.5999,0.1899 c-0.0801,0.03-0.16,0.0601-0.24,0.0801c-0.0701,0.02-0.1401,0.0399-0.2001,0.0599c-0.02,0.01-0.0399,0.01-0.0599,0.02 c-0.03,0.01-0.0601,0.02-0.0901,0.03c-4.37,1.33-8.47,1.84-11.61,1.84h-2.17c-15.4399,0-34.59,0-34.59,0s-19.15,0-34.6,0h-2.1699 c-13.02,0-42.51-8.8099-39.3101-48.14v0.1901c5.49,0.85,30.0701,4.27,70.1899,4.52c0.6301,0,1.28,0.0099,1.92,0.0099 c0.92,0.01,1.85,0.01,2.7899,0.01c1.52,0,3.03,0,4.51-0.01c40.9501-0.1799,66.05-3.6799,71.5801-4.5299 c0.7-0.11,1.09-0.1801,1.1599-0.1901C577.3049,730.595,577.355,732.855,577.395,734.885z"
    />
    <path
      id="_x34_"
      className="st3 Sun_Roof"
      d="M539.7749,480.255H462.585c-4.72,0-8.55,3.83-8.55,8.55v31.06c0,4.73,3.8301,8.5601,8.55,8.5601 h77.1899c4.73,0,8.5601-3.8301,8.5601-8.5601v-31.06C548.335,484.085,544.5049,480.255,539.7749,480.255z M539.7749,480.255H462.585 c-4.72,0-8.55,3.83-8.55,8.55v31.06c0,4.73,3.8301,8.5601,8.55,8.5601h77.1899c4.73,0,8.5601-3.8301,8.5601-8.5601v-31.06 C548.335,484.085,544.5049,480.255,539.7749,480.255z"
    />
    <path
      id="_x33_"
      className="st0 Roof"
      d="M577.095,554.8051c0.7-20.3401,3.2-47.57,6.1699-74.56c0.6001-5.39,1.2101-10.78,1.8301-16.1 c-0.14,0.21-1.61,2.23-6.9299,1.38c-4.3801-0.69-32.05-5.36-76.9801-5.36c-44.9401,0-72.6,4.67-76.98,5.36 c-5.62,0.9-6.9401-1.4-6.9401-1.4c1.23,10.56,2.4301,21.38,3.52,32.02c2.2001,21.5301,3.92,42.32,4.48,58.6601 c0.1901,5.6599,0.3601,11.59,0.49,17.71v0.1801c1.1602,53.8899-0.0199,122.8899-0.6499,155.4199v0.1901 c5.49,0.85,30.0701,4.27,70.1899,4.52c0.6301,0,1.28,0.0099,1.92,0.0099c0.92,0.01,1.85,0.01,2.7899,0.01c1.52,0,3.03,0,4.51-0.01 c40.9501-0.1799,66.05-3.6799,71.5801-4.5299c0.7-0.11,1.09-0.1801,1.1599-0.1901c-0.5-25.98-1.3398-75.22-1.0798-121.45 C576.2749,588.355,576.5549,570.525,577.095,554.8051z M548.335,519.865c0,4.73-3.8301,8.5601-8.5601,8.5601H462.585 c-4.72,0-8.55-3.8301-8.55-8.5601v-31.06c0-4.72,3.8301-8.55,8.55-8.55h77.1899c4.73,0,8.5601,3.83,8.5601,8.55V519.865z"
    />
    <path
      id="_x32__1_"
      className="st3 Front_Glass"
      d="M596.8149,377.135l-11.71,86.99c0,0,0,0.02-0.01,0.02c-0.14,0.21-1.61,2.23-6.9299,1.38 c-4.3801-0.69-32.05-5.36-76.9801-5.36c-44.9401,0-72.6,4.67-76.98,5.36c-5.62,0.9-6.9401-1.4-6.9401-1.4 c-0.02-0.15-0.0399-0.31-0.0599-0.47l-11.65-86.52c0,0,1.16-24.46,20.8201-33.78c19.6599-9.32,48.1299-13.27,74.8099-13.27 s55.15,3.95,74.8099,13.27c16.4302,7.79,19.9401,26.16,20.6501,31.98C596.7849,376.475,596.8149,377.135,596.8149,377.135z"
    />
    <path
      id="_x31__1_"
      className="st0 Hood"
      d="M565.0149,246.375c-3.4299-4.11-20.99-6.62-35.1199-7.48c-0.02,0-0.03,0-0.03,0 c-3.72-0.24-7.2-0.35-10.1201-0.35h-19.74c0,0-5.7,0-19.75,0c-2.9199,0-6.3999,0.11-10.1199,0.35c0,0-0.01,0-0.03,0 c-14.13,0.86-31.6899,3.3701-35.12,7.48c-4.34,5.2-32,51.41-37.9601,117.79l8.53,12.97c0,0,1.16-24.46,20.8201-33.78 c19.6599-9.32,48.1299-13.27,74.8099-13.27s55.15,3.95,74.8099,13.27c16.4302,7.79,19.9401,26.16,20.6501,31.98l6.33-11.17 C597.0149,297.785,569.355,251.575,565.0149,246.375z M498.635,258.325l-10.04-16.23h20.09L498.635,258.325z"
    />
    <g id="_x38_2">
      <polygon
        className="st0 Tow_Hook_Cover_Front"
        points="461.1249,163.965 461.1249,167.605 455.3149,169.455 449.5049,167.605 449.5049,163.965  455.3149,162.4951  "
      />
      <polygon
        className="st0 Tow_Hook_Cover_Rear"
        points="458.643,848.0329 458.643,852.5097 452.833,854.785 447.023,852.5097 447.023,848.0329  452.833,846.225  "
      />
    </g>
  </svg>
)}
export default CarSVG2;
